<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
    aria-hidden="true"
  >
    <path
      d="M14.529 1.46833C14.2233 1.16255 13.7779 1.05677 13.369 1.18833L1.88193 4.88077C1.44549 5.02122 1.14327 5.39099 1.09349 5.84699C1.04371 6.3021 1.25971 6.72877 1.65527 6.95899L5.72282 9.33144L9.2366 5.81677C9.49705 5.55633 9.91927 5.55633 10.1797 5.81677C10.4402 6.07722 10.4402 6.49944 10.1797 6.75988L6.66505 10.2745L9.03749 14.3421C9.24638 14.6994 9.61527 14.9101 10.0215 14.9101C10.0642 14.9101 10.1077 14.9074 10.1513 14.903C10.6064 14.8532 10.977 14.551 11.1166 14.1154L14.8099 2.62922C14.9415 2.21766 14.8339 1.77322 14.529 1.46833Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
/** Purpose: Render the composer send glyph using the caller-provided current color. */
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SendIcon',
  props: {
    color: {
      type: String,
      default: '#2e9b4a',
    },
  },
})
</script>
